enum State_Type {
  pending,
  approved,
  deleted,
}

export default State_Type;
